import * as z from "zod";
import { GRANT_REQUEST_NOTE_MAX_LENGTH } from "../grantRequests";
import { SCOPE_MANAGE_GRANTS_PERMISSION } from "../rbac/roles";
import { mutator } from "./mutator";

// A reviewer rejecting a request (the requester withdrawing their own is
// cancelGrantRequest). Same authority as approving it — you can reject a share
// request only if you could have granted it directly.
export const dismissGrantRequestSchema = z.object({
  requestId: z.string(),
  note: z.string().max(GRANT_REQUEST_NOTE_MAX_LENGTH).optional(),
});

export const dismissGrantRequest = mutator({
  description:
    "Declines a request to share a connector, optionally explaining why.",
  interactionType: "review",
  schema: dismissGrantRequestSchema,
  resolve: {
    request: { kind: "grantRequest", from: "requestId" },
  },
  permissions: [
    {
      permission: ({ args }) =>
        SCOPE_MANAGE_GRANTS_PERMISSION[args.request.scopeKind],
      scopeId: ({ args }) => args.request.scopeId,
    },
  ],
  fn: async ({ tx, args: { request } }) => {
    await tx.mutate.grantRequests.delete({ id: request.id });
  },
});
